import { backendProtocol, backendHost, backendPort } from '../endpoints.js';

export const HELPDESK = backendProtocol + backendHost + backendPort + '/api/helpdesk';
export const START_CHAT_CONVERSATION = HELPDESK + '/chat/startConversation';
export const SEND_CHAT_MESSAGE = HELPDESK + '/chat/sendMessage';
export const GET_CHAT_CONVERSATION = HELPDESK + '/chat/getConversation';
